'use client';

import { atom, Provider } from 'jotai';
import { ReactNode } from 'react';
import { useHydrateAtoms } from 'jotai/utils';

import {
  GlossaryTermPageGlossaryTermFragment,
  GlossaryTermPageRelatedGlossaryTermFragment,
  GlossaryTermPageRelatedBlogPostFragment,
} from './query.generated';

export const glossaryTermAtom = atom<GlossaryTermPageGlossaryTermFragment | undefined>(undefined);

export type RelatedArticleType = GlossaryTermPageRelatedGlossaryTermFragment | GlossaryTermPageRelatedBlogPostFragment;

export const relatedContentsAtom = atom<RelatedArticleType[]>(
  (get) =>
    get(glossaryTermAtom)?.relatedContentsCollection?.items.filter((x): x is NonNullable<typeof x> => Boolean(x)) ?? [],
);

function GlossaryPageAtomsHydrator({
  glossaryTerm,
  children,
}: {
  glossaryTerm: GlossaryTermPageGlossaryTermFragment;
  children: ReactNode;
}) {
  useHydrateAtoms([[glossaryTermAtom, glossaryTerm]]);
  return children;
}

export const GlossaryTermPageJotaiProvider = ({
  children,
  glossaryTerm,
}: {
  children?: ReactNode;
  glossaryTerm: GlossaryTermPageGlossaryTermFragment;
}) => {
  return (
    <Provider>
      <GlossaryPageAtomsHydrator glossaryTerm={glossaryTerm}>{children}</GlossaryPageAtomsHydrator>
    </Provider>
  );
};
